// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"146":"10eeb0eb","177":"cbbf212b","225":"a0c3c2ea","227":"4fca07a8","324":"db9d1d5c","333":"80b656a3","535":"5ae1e456","626":"c74e1053","662":"cdfa3ac4","771":"e4113e43","914":"e928b66c","944":"716bd605"}[chunkId] + ".js";
};